import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-verificacion',
  templateUrl: './verificacion.component.html',
  styleUrls: ['./verificacion.component.css']
})
export class VerificacionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
